import React, { useState } from 'react';
import { api } from '../utils/api';
import TwoFactorSetupFlow from './TwoFactorSetupFlow';
import LogoMark from './LogoMark';

export default function TwoFactorGate({ onDone }) {
  const [started, setStarted] = useState(false);
  const [skipping, setSkipping] = useState(false);

  const handleSkip = async () => {
    setSkipping(true);
    try {
      await api.dismiss2FAPrompt();
    } catch (err) {
      console.error(err);
    } finally {
      onDone();
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logoRow}>
          <LogoMark size={28} />
          <span style={styles.logoText}>Boring Budgeting</span>
        </div>

        <h1 style={styles.heading}>Secure your account</h1>
        <p style={styles.subtext}>
          Your account holds real financial data. We strongly recommend
          enabling two-factor authentication with an app like Google
          Authenticator, Authy, or Keeper.
        </p>

        {!started ? (
          <>
            <button style={styles.primaryBtn} onClick={() => setStarted(true)}>
              Set Up 2FA Now
            </button>
            <button style={styles.skipBtn} onClick={handleSkip} disabled={skipping}>
              {skipping ? '...' : "Skip for now (we'll ask again later)"}
            </button>
          </>
        ) : (
          <TwoFactorSetupFlow onComplete={onDone} onCancel={() => setStarted(false)} />
        )}
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    background: '#0a0f1e',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1.5rem',
  },
  card: {
    background: '#111827',
    border: '1px solid #1e2a3a',
    borderRadius: '20px',
    padding: '2rem',
    maxWidth: '440px',
    width: '100%',
  },
  logoRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    marginBottom: '1.75rem',
  },
  logoText: {
    fontSize: '1.1rem',
    fontWeight: '800',
    color: '#fff',
    fontFamily: "'Syne', sans-serif",
  },
  heading: {
    color: '#fff',
    fontSize: '1.3rem',
    fontWeight: '800',
    fontFamily: "'Syne', sans-serif",
    margin: '0 0 0.6rem',
  },
  subtext: {
    color: '#9ca3af',
    fontSize: '0.85rem',
    lineHeight: '1.6',
    marginBottom: '1.5rem',
  },
  primaryBtn: {
    background: '#00d4aa',
    color: '#0a0f1e',
    border: 'none',
    borderRadius: '10px',
    padding: '0.85rem',
    fontSize: '0.9rem',
    fontWeight: '700',
    cursor: 'pointer',
    fontFamily: "'Syne', sans-serif",
    width: '100%',
    marginBottom: '0.75rem',
  },
  skipBtn: {
    background: 'transparent',
    color: '#6b7280',
    border: 'none',
    fontSize: '0.8rem',
    cursor: 'pointer',
    fontFamily: "'Syne', sans-serif",
    width: '100%',
    textAlign: 'center',
    padding: '0.5rem',
  },
};
